<template>
  <div class="widget" :class="{'no-header': !headerText}">
    <overlay :is-loading="isLoading"></overlay>
    <vuestic-pre-loader v-if="isLoading" :is-loading="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
    <div class="widget-header" v-if="headerText">
      {{headerText}}
      <slot name="header"></slot>
      <div class="flex-fill">
        <div class="pull-right">
          <slot name="header-right"></slot>
        </div>
      </div>
    </div>
    <div class="widget-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Overlay from 'components/layout/sidebar/Overlay.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'vuestic-widget',
  props: ['headerText', 'headerValue', 'isLoading'],
  components: {Overlay},
  computed: {
    currentId () {
      return this.$route.params.id
    },
    ...mapGetters([
      'isLoadingLight'
    ]),
  },
}
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";

  .widget {
    background: $widget-bg;
    box-shadow: $widget-box-shadow;
    margin-bottom: $widget-mb;
    padding: 0;
    position:relative;

    &.no-header {
      .widget-body {
        height: $widget-body-no-header-height;
      }
    }

    &.larger-padding {
      .widget-body {
        padding: $widget-larger-padding;
      }
    }

    &.no-h-padding {
      .widget-body {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &.no-v-padding {
      .widget-body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.brand-info {
      background-color: $brand-info;
      color: $white;
      box-shadow: $widget-info-shadow;
    }

    &.brand-danger {
      background-color: $brand-danger;
      color: $white;
      box-shadow: $widget-danger-shadow;
    }

    &.info-widget {
      border-top: $info-widget-border;

      &.brand-info {
        border-top-color: $brand-info;
      }

      &.brand-danger {
        border-top-color: $brand-danger;
      }
    }

    .widget-body {
      height: $widget-body-with-header-height;
      padding: $widget-padding;
    }

    .widget-header {
      height: $widget-header-height;
      padding: 0 $widget-padding;
      border-bottom: $widget-header-border;
      font-size: $font-size-larger;
      font-weight: 600;
      display: flex;
      align-items: center;
      .text-primary{
        margin:0 5px;
        // text-transform: uppercase;
      }
      .flex-fill{
        height:100%;
        float:right;
        margin-left: auto;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget.vue